import "jquery";
import 'bootstrap';
import '../scss/bootstrap.scss';
import './Modal';

const menuTriggerId = 'menu-trigger';
const menuId = 'mobile-menu';
const menuOpenClass = 'nav-open';
const bgModalId = 'bg-overlay';
const bgModalClass = 'bg-overlay';
const bgModalActiveClass = 'active';
const modalTriggerClass = 'video-overlay';

const subMenuTriggerId = 'submenu-trigger';
const subMenuNavOpenClass = 'sm-open';

const showMobileHeaderClass = 'show-mobile-header';
const showMobileSubMenuClass = 'show-mobile-sub-menu';
const showNavViewportBreakpoint = 992;
const menuNavOpenClass = 'dd-open';

const dropDownMenuTriggerSelector = '.dropdown';
const mainDropDownTriggerSelector = 'li.dropdown.nav-item';
const dropDownMenuSelector = '.dropdown-menu';

const subNavBarClass = 'sub-nav-bar';
const showSubNavBarClass = 'show-sub-nav-bar';

const setHoverTriggers = ($) => {
    $(document).on('click', '.hover-effect-image', function() {
        let target = this.querySelector('a');
        target.click();
    });
}


// Mobile Menu Javascript

const openMobileMenu = () => {
    showOverlayBackground();
    document.body.classList.add(menuOpenClass);
}

export const closeMobileMenu = () => {
    hideOverlayBackground();
    document.body.classList.remove(menuOpenClass);
}

const setOpenOverlay = () => {
    const overlayTrigger = document.getElementsByClassName(modalTriggerClass);
    if (overlayTrigger) {
        for (var i = 0; i < overlayTrigger.length; i++) {
            let trigger = overlayTrigger[i];
            trigger.addEventListener('click', function(e){
                e.preventDefault();
                const href = this.href;
                
                showOverlayBackground();

                const modal = document.createElement('div');
                modal.id = modalTriggerClass + '-' + i;
                modal.classList.add(modalTriggerClass + '-modal');

                const closeBtn = document.createElement('div');
                closeBtn.classList.add('close-modal');

                const closeBtnIcon = document.createElement('i');
                closeBtnIcon.classList.add('material-icons');
                closeBtnIcon.innerHTML = 'close';

                closeBtn.appendChild(closeBtnIcon);

                closeBtn.onclick = () => {
                    hideOverlayBackground();
                    modal.remove();
                };

                modal.appendChild(closeBtn);
                modal.appendChild(getVideoEmbed(href));
                
                document.body.appendChild(modal);
                
            });
        }
    }
}

const showOverlayBackground = () => {
    let bgModal: any;
    if (!document.getElementById(bgModalClass)) {
        bgModal = document.createElement('div'); 
        bgModal.id = bgModalId;
        bgModal.classList.add(bgModalClass);
        document.body.appendChild(bgModal);
    } else {
        bgModal = document.getElementsByClassName(bgModalId);
    }
    fadeIn(bgModal, 100);
}

const hideOverlayBackground = () => {
    const bgModal = document.getElementById(bgModalId);
    if (bgModal) {
        bgModal.remove();
    }
}

const fadeIn = (el, time) => {
    el.style.opacity = 0;
  
    var last = +new Date();
    var tick = function() {
      el.style.opacity = +el.style.opacity + (<any>new Date() - last) / time;
      last = +new Date();
  
      if (+el.style.opacity < 1) {
        (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
      }
    };
  
    tick();
  }
  
const fadeOut = (target) => {
    const fadeEffect = setInterval(() => {
        if (!target.style.opacity) {
            target.style.opacity = 1;
        }
        if (target.style.opacity > 0) {
            target.style.opacity -= 0.1;
        } else {
            clearInterval(fadeEffect);
            target.remove();
        }
    }, 200);
}

const setMobileMenu = () => {
    const mobileMenuTrigger = document.getElementById(menuTriggerId);
    if(mobileMenuTrigger) {
        mobileMenuTrigger.addEventListener("click", function(){
            const menuIsOpen = document.body.classList.contains(menuOpenClass) ? true : false;
            if (menuIsOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }
}

// Main Menu JavaScript
const toggleMenu = function(e) {
    
    const trigger = this;
    const dropDownIsOpen:boolean = trigger.classList.contains(menuNavOpenClass) ? true : false;
    const menu:any = trigger.parentNode.querySelectorAll(dropDownMenuSelector)[0];

    const allMenus:any = document.querySelectorAll(dropDownMenuSelector);
    const allTriggers:any = document.querySelectorAll('.nav-link');
    
    const isToggleTrigger = e.target.classList.contains('menu-toggle-trigger') ? true : false;

    if (!dropDownIsOpen || isToggleTrigger) { 
        allTriggers.forEach(function(triggerItem) {
            triggerItem.classList.remove(menuNavOpenClass);
        });
    
        allMenus.forEach(function(menuItem) {
            menuItem.style.display = "none";
        });

        if (!dropDownIsOpen) {
            menu.style.display = "block"; 
            this.classList.add(menuNavOpenClass);
        }
        e.preventDefault();
    }
}

const openMainDropDownNav = (ev, listItem?) => {
    const navItem = (listItem) ? listItem : ev.target;
    showOverlayBackground();

    navItem.classList.add('show');
    const dropDownMenu = navItem.querySelector('.dropdown-menu');
    dropDownMenu.classList.add('show');

}

const closeMainDropDownNav = (ev, listItem?) => {
    const navItem = (listItem) ? listItem : ev.target;
    navItem.classList.remove('show');
    hideOverlayBackground();

    const dropDownMenu = navItem.querySelector('.dropdown-menu');
    dropDownMenu.classList.remove('show');
    dropDownMenu.removeAttribute('style');
}

const removeAllMenuEvents = () => {
    const dropDownTriggers = document.querySelectorAll(dropDownMenuTriggerSelector);
    for (var i = 0; i < dropDownTriggers.length; i++) {
        const menuItem = dropDownTriggers[i]; 
        const menuItemAnchor = dropDownTriggers[i].querySelector('a');  
        closeMainDropDownNav(null, menuItem);
        menuItemAnchor.removeEventListener('click', toggleMenu);
        menuItem.removeEventListener('mouseenter', openMainDropDownNav);
        menuItem.removeEventListener('mouseleave', closeMainDropDownNav);
    }
}

const setMenuDropdowns = () => {
    const dropDownTriggers = document.querySelectorAll(dropDownMenuTriggerSelector);
    const isMobileNavVisible = document.body.classList.contains(showMobileHeaderClass) ? true : false;

    for (var i = 0; i < dropDownTriggers.length; i++) {
        const menuItem = dropDownTriggers[i];
        const menuItemAnchor = dropDownTriggers[i].querySelector('a');  
        const isFooter = menuItem.closest('ul').id === 'menu-footer-menu' ? true : false;
        const hasTrigger = menuItemAnchor.querySelector('span.menu-toggle-trigger') ? true : false;

        if(!hasTrigger) {
            let toggleArrow = <HTMLSpanElement>document.createElement('span');
            toggleArrow.classList.add('menu-toggle-trigger');
            menuItemAnchor.appendChild(toggleArrow);
        }
        
        if (isMobileNavVisible) {
            menuItemAnchor.addEventListener('click', toggleMenu);
            if (!isFooter) {
                menuItem.removeEventListener('mouseenter', openMainDropDownNav);
                menuItem.removeEventListener('mouseleave', closeMainDropDownNav);
            }
        } else {
            menuItemAnchor.removeEventListener('click', toggleMenu);
            if(!isFooter) {
                menuItem.addEventListener('mouseenter', openMainDropDownNav);
                menuItem.addEventListener('mouseleave', closeMainDropDownNav);
            }
        }
    }
}

const getViewportWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth;
}

const isMobileNav = () => {
    if (getViewportWidth() < showNavViewportBreakpoint) return true;
    else return false;
}

const checkNavDisplay = function () {
    if (!isMobileNav()) {
        document.body.classList.remove(menuOpenClass);
        document.body.classList.remove(showMobileHeaderClass);
    } else {
        document.body.classList.add(showMobileHeaderClass);
    }
    setMenuDropdowns();
}

// On resize events, recalculate and log
window.addEventListener('resize', function () {
    removeAllMenuEvents();
    checkNavDisplay();
    closeMobileMenu();
}, false);

// Sub Menu Mobile Treatment
const closeSubMobileMenu = () => {
    var bgModal = document.getElementById(bgModalId);
    if (bgModal) bgModal.remove();

    document.body.classList.remove(showMobileSubMenuClass);

    var subMenuTrigger = document.getElementById(subMenuTriggerId)
    if(subMenuTrigger) document.getElementById(subMenuTriggerId).classList.remove(subMenuNavOpenClass);
}

const getVideoEmbed = url => {
    const isVimeo = (/https:\/\/vimeo.com\/\d{9}(?=\b|\/)/.test(url)) ? true : false;
    let regex;
    
    const embedContainer = document.createElement('div');
    embedContainer.classList.add('embed-container');

    const videoIframe = document.createElement('iframe');
    videoIframe.frameBorder = '0';
    videoIframe.allow = 'autoplay; fullscreen';
    videoIframe.allowFullscreen = true;

    embedContainer.appendChild(videoIframe);

    if (isVimeo) {
        regex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
        const videoId = url.match(regex);
        videoIframe.src = "//player.vimeo.com/video/" + videoId[1] + '?title=0&byline=0&portrait=0&autoplay=1';
        return embedContainer;
    }
};

const setRevealTriggers = () => {
    const triggers = document.getElementsByClassName('reveal-trigger');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];
            trigger.addEventListener('click', function(e){
                e.preventDefault();
                const container = this.closest('.reveal-container');
                const isOpen = (container.classList.contains('open')) ? true : false;
                const target = this.closest('.reveal-container').querySelector('.reveal-content');
                const closedLabel = this.dataset.closedLabel;
                const openLabel = this.dataset.openLabel;
                const triggerLabel = this.querySelector('.trigger-label');

                if (isOpen) {
                    container.classList.remove('open');
                    triggerLabel.innerHTML = closedLabel;
                    target.style.height = '0px';
                } else {
                    container.classList.add('open');
                    triggerLabel.innerHTML = openLabel;
                    target.style.height = target.scrollHeight + 'px';
                }

                //container.scrollIntoView();
            });
        }
    }
}

const setNavLinks = () => {
    const triggers = document.getElementsByClassName('close-menu');
    if (triggers) {
        for (var i = 0; i < triggers.length; i++) {
            let trigger = triggers[i];
            
            trigger.addEventListener('click', function(e){
                closeMobileMenu();
            });
        }
    }
}
/*
jQuery('#mobile-menu').on('hide.bs.dropdown', function (e) {
    var target = jQuery(e.target);
    if(target.hasClass("keepopen") || target.parents(".keepopen").length){
        return false; // returning false should stop the dropdown from hiding.
    }else{
        return true;
    }
});
*/
setOpenOverlay();
setMobileMenu();
checkNavDisplay();
setRevealTriggers();
setHoverTriggers(jQuery);